import * as angular from 'angular';

import { ComponentDefinition, AlarmLevel, TimeUnit, EmailEventDTO, EmailEventType, MailingJobDefinitionDto } from '../../../models/index';
import { IRootScope } from '../../../IRootScope';
import { IMailingJobService } from '../../../services';
import { mailingJobDeleted, mailingJobUpdated, isEditMode, formDirtyChanged, guidEmpty } from '../../../common/';

class EmailsStateController implements angular.IComponentController {
    static controllerId = 'emailsState';

    hasDirtyForm: boolean;
    isEditMode: boolean;
    isLoading: boolean;
    jobs: MailingJobDefinitionDto[];
    mailEvents: EmailEventDTO[];
    selectedItem: any; // scheduled or event based...

    private _watchers: any[];

    static $inject = ['$scope', '$rootScope', 'mailingJobService'];

    constructor(
        private $scope: angular.IScope,
        private $rootScope: IRootScope,
        private _mailingJobService: IMailingJobService
    ) {
    }

    $onInit() {
        this.isEditMode = this.$rootScope.isEditMode;
        this.selectedItem = null;
        this.refresh();

        this.$scope.$on(mailingJobDeleted, (event, data) => {
            this.refresh();
        });

        this.$scope.$on(mailingJobUpdated, (event, data) => {
            this.refresh();
        });

        this.$scope.$on(isEditMode, (event, data) => {
            this.isEditMode = !!data;
        });

        this._watchers = [
            this.$rootScope.$on(formDirtyChanged, (event, data) => { this.hasDirtyForm = data; })
        ];
    }

    $onDestroy() {
        try {
            if (this._watchers && this._watchers.length) {
                this._watchers.forEach(w => w());
            }
        } catch (e) {
            console.error(e);
        }
    }

    private refresh() {
        this.isLoading = true;
        this._mailingJobService
            .getAll()
            .then(data => {
                this.jobs = data;
                this.selectedItem = null;
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    unselectItem($event: angular.IAngularEvent) {
        if (!this.hasDirtyForm) {
            this.unselect($event);
        }
    }

    unselect($event) {
        if (!$event.isDefaultPrevented()) {
            this.setSelectedItem(null);
        }
    }

    setSelectedItem(item) {
        this.selectedItem = item;
    }

    selectItem(item, $event: angular.IAngularEvent) {
        if (!this.hasDirtyForm) {
            this.selectedItem = item;
            $event.preventDefault();
        }
    }

    drop(data) {
        if (data.itemId.indexOf('mailingJob') >= 0) {
            const item: any = {
                frequency: '0 0 * * * ?'
            };
            this.jobs.push(item);
            this.selectedItem = item;
        }
    }

    dropEvent(data) {
        if (data.itemId.indexOf('eventEmail') >= 0) {
            const item: EmailEventDTO = {
                guid: guidEmpty,
                actionGuid: guidEmpty,
                alarmLevel: AlarmLevel.Critical,
                status: 0,
                snoozeTimeUnit: TimeUnit.Hour,
                snoozeInterval: 0,
                dateFormat: '',
                event: EmailEventType.AlarmRaised,
                eventEmailDefinition: {
                    body: '',
                    connectionPointGuid: '',
                    from: '',
                    //recipientList: [],
                    recipients: { approvalLevels: [], roles: [], users: [], userGroups:[], keywords: [] },
                    subject: '',
                    isExportToChildApplication: false
                },
                groupGuids: [],
                groupTypes: [],
                alarmCategories: [],
                approvalLevels: [],
                approvalStrategyGuid: guidEmpty,
                ticketStatuses: []
            };
            this.mailEvents.push(item);
            this.selectedItem = (<any>item);
        }
    }
}

export const wtEmailsState: ComponentDefinition = {
    componentId: 'wtEmailsState',
    controller: EmailsStateController,
    template: require('./emailsState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};